import { ReactNode } from 'react';

export const Trademark = ({children}:{ children: ReactNode }) => (
  <span style={{wordSpacing:'inherit'}}>
    {children}
    <sup style={{ fontSize: '.6em'}}>
      TM
    </sup>
  </span>
);
